module.exports = __webpack_public_path__ + "static/media/policy-download.3c916de3.svg";